<template>
  <div class="status-row">
    <div
      class="status"
    >
      <trigger
        class="status-switch"
        :disabled="loading"
        v-model="is_permanent_response_link"
      />

      <span class="name">{{$tr('admin_console.company.settings.common.public-links')}}</span>
    </div>
    <div
      class="status"
    >
      <trigger
        class="status-switch"
        :disabled="loading"
        v-model="is_test"
      />

      <span class="name">{{$tr('admin_console.company.settings.common.is_test')}}</span>
    </div>
    <div
      class="status"
    >
      <trigger
        class="status-switch"
        :disabled="loading"
        v-model="is_videoresume"
      />

      <span class="name">{{$tr('admin_console.company.settings.common.is_videoresume')}}</span>
    </div>

    <div
      class="status"
    >
      <trigger
        class="status-switch"
        :disabled="loading"
        v-model="is_onboarding"
      />

      <span class="name">Onboarding</span>
    </div>
  </div>
</template>

<script>
import { STORE_PREFIX } from '../../constants.js';
import { mapGetters } from 'vuex';

import Trigger from '@/components/shared/MinimalisticTrigger.vue'

export default {
  name: 'common',

  props: ['companyId'],

  components: {
    Trigger
  },

  data () {
    return {
      if_permanent_link_enabled: null,
      is_test_enabled: null,
      is_videoresume_enabled: null,
      is_onboarding_enabled: null
    }
  },

  computed: {
    ...mapGetters(STORE_PREFIX + 'admin', {
      loading: 'company/loading',
      company: 'company/one'
    }),

    is_permanent_response_link: {
      get() {
        if (this.if_permanent_link_enabled === null) {
          return this.company ? this.company.is_permanent_response_link : false;
        }

        return this.if_permanent_link_enabled;
      },

      set(val) {
        this.if_permanent_link_enabled = val;

        this.$store.dispatch(STORE_PREFIX + 'admin/company/update', {
          id: this.companyId,
          is_permanent_response_link: this.if_permanent_link_enabled
        })
      }
    },

    is_test: {
      get() {
        if (this.is_test_enabled === null) {
          return this.company ? this.company.is_test : false;
        }

        return this.is_test_enabled;
      },

      set(val) {
        this.is_test_enabled = val;

        this.$store.dispatch(STORE_PREFIX + 'admin/company/update', {
          id: this.companyId,
          is_test: this.is_test_enabled
        })
      }
    },

    is_videoresume: {
      get() {
        if (this.is_videoresume_enabled === null) {
          return this.company ? this.company.is_videoresume : false;
        }

        return this.is_videoresume_enabled;
      },

      set(val) {
        this.is_videoresume_enabled = val;

        this.$store.dispatch(STORE_PREFIX + 'admin/company/update', {
          id: this.companyId,
          is_videoresume: this.is_videoresume_enabled
        })
      }
    },

    is_onboarding: {
      get() {
        if (this.is_onboarding_enabled === null) {
          return this.company ? this.company.is_onboarding_enabled : false;
        }

        return this.is_onboarding_enabled;
      },

      set(val) {
        this.is_onboarding_enabled = val;

        this.$store.dispatch(STORE_PREFIX + 'admin/company/update', {
          id: this.companyId,
          is_onboarding_enabled: this.is_onboarding_enabled
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .status-row {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    flex-direction: column;
    width: 640px;
  }


  .status {
    display: flex;
    align-items: center;
    padding: 20px 20px 20px 10px;
    box-sizing: border-box;
    width: 100%;
    border-bottom: 1px solid #DDDDDD;
    position: relative;

    &:hover { 
      background: #F1F2F2;
    }

    .status-switch { margin-right: 25px; }

    .name {
      font-size: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 5px;
    }
  }
</style>
